import { CustomerRow } from '@/Screens/Dashboard/Customers/types';
import { HeaderItem } from '@/types/headerItem';

export const createHeaders = (
  tr: (original: string) => string,
): readonly HeaderItem<CustomerRow>[] => [
  {
    label: tr('TYPE'),
    sortable: false,
    key: 'type',
  },
  {
    label: tr('NAME'),
    sortable: false,
    key: 'name',
  },
  {
    label: tr('VERIFICATION_STATUS'),
    sortable: false,
    key: 'verificationStatus',
  },
  {
    label: tr('RESULT'),
    sortable: false,
    key: 'verificationResult',
  },
  {
    label: tr('CREATED'),
    sortable: true,
    key: 'createdDate',
  },
];
